import Template from './template';
export default Template;
